import { InspectorPanelAccordionExport } from "../../accordion/export/InspectorPanelAccordionExport"
import { InspectorPanelMetadata } from "../../FlightPanelMetadata"
import { useImageDownloadButtonData } from "plugins/ColorFinder/ImageColorFinder/useImageColorFinderDownloadButtonData"
import { GenericUpload, SidePanelLayer } from "@nova/constants"
import { useAppSelector } from "integrations/redux/hooks"
import { selectColorFinderImagesAndUploadsByFlightId } from "features/entity-caching/images/colorfinder/selectors"
import { selectImageColorFinderFlightById } from "features/entity-caching/flights/selectors"

export const InspectorPanelICFData = ({ id }: { id: string }) => {
    const flight = useAppSelector(selectImageColorFinderFlightById(id))
    const uploads = useAppSelector(selectColorFinderImagesAndUploadsByFlightId(flight.id))
    const downloadOptions = useImageDownloadButtonData()

    return (
        <div className="mb-2 flex flex-col gap-2">
            {/* Export */}
            <InspectorPanelAccordionExport
                exportOptions={downloadOptions.exportOptions}
                canOnlyPickOne={true}
            />

            <InspectorPanelMetadata
                entity={flight as SidePanelLayer}
                uploads={uploads as GenericUpload[]}
                completedUploadCount={1}
            />
        </div>
    )
}
